import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthContext";
import { hasActiveSubscription } from "../../utils/subscription";
import EntryMoment from "./EntryMoment";
import FirstSessionUpgradeCard from "../subscription/FirstSessionUpgradeCard";
import { useAstriaCopy } from "./copy";
import { isAppLanguage } from "../../utils/languages";

const seenKey = (userId: string) => `astria_free_entry_seen_${userId}`;

/** Applies the language tint app-wide and shows the Free plan welcome once per user. */
const FreeEntryGate: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const { i18n } = useTranslation();
  const c = useAstriaCopy();
  const [show, setShow] = useState(false);
  const [card, setCard] = useState(false);

  useEffect(() => {
    const code = (i18n.language || "en").split("-")[0];
    const lang = isAppLanguage(code) ? code : "en";
    document.documentElement.setAttribute("data-astria-lang", lang);
  }, [i18n.language]);

  useEffect(() => {
    if (!isAuthenticated || !user?._id) return;
    if (hasActiveSubscription(user)) return;
    try {
      if (localStorage.getItem(seenKey(user._id))) return;
      localStorage.setItem(seenKey(user._id), "1");
    } catch {
      return;
    }
    setShow(true);
  }, [isAuthenticated, user]);

  if (card) return <FirstSessionUpgradeCard onClose={() => setCard(false)} />;
  if (!show) return null;
  return (
    <EntryMoment
      headline={c("freeEntry")}
      glow="minimal"
      onDone={() => {
        setShow(false);
        setCard(true);
      }}
    />
  );
};

export default FreeEntryGate;
